export default "__VITE_ASSET__DlJiZT55__"